var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hr',{staticClass:"gradient my-10"})
}
var staticRenderFns = []

export { render, staticRenderFns }